import { all, AllEffect } from 'redux-saga/effects';

export function combineAllWatchers(watchers: (() => Generator)[]) {
	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	return function* combinedWatcherSaga(): Generator<AllEffect<Generator>, unknown, unknown> {
		const activeWatchers = watchers.map((watcher) => watcher());

		return yield all(activeWatchers);
	};
}
